export const generateUniqueId = (str?: string): string => {
  const dateString = Date.now().toString(36);
  const randomness = Math.random().toString(36).substr(2);
  const res = dateString + randomness;
  return `${res}_${str}`;
};

export const uid = (): string => {
  const dateString = Date.now().toString(36);
  const randomness = Math.random().toString(36).substr(2);
  return dateString + randomness;
};
